const initial = {
  status: 'hidden',
  show: false,
  resolve: null,
  reject: null,
};

export default {
  namespaced: true,
  state: {...initial},
  actions: {
    clear({commit}) {
      commit('clear');
    },
    show({commit}) {
      return new Promise((resolve, reject) => {
        commit('set', {
          show: true,
          resolve,
          reject
        });
      });
    },
  },
  mutations: {
    clear(state) {
      state.show = initial.show;
      state.resolve = initial.resolve;
      state.reject = initial.reject;
    },
    set(state, {show, resolve, reject}) {
      state.show = show;
      state.resolve = resolve;
      state.reject = reject;
    },
  },
};
